/*
Defines the custom element <ravel-p5-canvas>
*/

import { RavelP5Canvas } from './src/RavelP5Canvas.js';

customElements.define('ravel-p5-canvas', RavelP5Canvas);
